import React from "react";
import { Button, dialog, InputString } from "../../../nq-component";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { exportCSVUseCase } from "../../../usecases/csv/usecases";
import { Progress, InfiniteScroll } from "../../../nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import NavBar from "../../../components/navbar";
import InputFactory from "../../../components/InputFactory";
import excludeFields from "../ExcludeField";
import { footer, html, object } from "framer-motion/client";
import DialogCreate from "../components/DialogCreate";
import DialogDelete from "../components/DialogDelete";
import DialogReset from "../components/DialogConfirmation";
import Table from "../../../components/Table";
import InterviewListPagePresenter from "./InterviewListPagePresenter";
import BaseListPage from "../../../base/BaseListPage";
import OnlineDetails from "../components/OnlineDetails";
import InterviewDetails from "../components/InterviewDetails";

class InterviewListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new InterviewListPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      locations: [],
      loading: false,
      total: 0,
      count: 0,
      showFilters: false,
      showDetails: false,
      appDetails: {},
      password: {},
    };
  }

  getCollectionName() {
    return "online_applicants";
  }

  onChangeObject(value, field) {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [field]: value,
      },
    }));
  }

  clickData(object, index) {
    this.setState({ showFilters: true, showDetails: true, appDetails: object });
  }

  onClickView() {
    const { appDetails } = this.state;
    this.navigateTo(
      `/coordinator/for-interview/form/${appDetails?.interviewCoordinator}/${appDetails?.id}/${appDetails?.recruiter?.id}`
    );
  }

  hideFilter() {
    this.setState({ showFilters: false, showDetails: false });
  }
  showFilter() {
    this.setState({ showFilters: true });
  }

  onChangeStatus(value, field) {
    const schema = this.getSchema(this.getCollectionName());
    this.presenter.onChangeStatus(value, schema);
  }
  onChangePosition(value, field) {
    const schema = this.getSchema(this.getCollectionName());
    this.presenter.onChangePosition(value, schema);
  }

  onSubmitPassword() {
    this.presenter.onSubmitPassword(this.state.password);
  }
  onChangeLocation(value, field) {
    const schema = this.getSchema(this.getCollectionName());
    this.presenter.onChangeLocation(value, schema);
  }

  onChangeReferenceNo(value, field) {
    const schema = this.getSchema(this.getCollectionName());
    this.presenter.onChangeReferenceNo(value, schema);
  }
  onChangeDate(value, field) {
    const schema = this.getSchema(this.getCollectionName());
    this.presenter.onChangeDate(value, schema);
  }

  onclickReset() {
    dialog.fire({
      html: (
        <>
          <DialogReset
            onChangeField={this.onChange.bind(this)}
            clickSubmit={this.onSubmitPassword.bind(this)}
            clickClose={() => dialog.close()}
          />
        </>
      ),
      footer: false,
    });
  }

  getAcl() {
    const user = this.getCurrentUser();
    return {
      read: ["*", user.id],
      write: ["*", user.id],
    };
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      objects,
      selected,
      count,
      progress,
      locations,
      showFilters,
      showDetails,
      appDetails,
    } = this.state;

    const statusOptions = [
      "New",
      "For Interview",
      "For Coordinator",
      "For Endorsement",
      "On-boarding",
      "Hired",
    ];

    if (!schema) return <Progress />;
    const user = this.getCurrentUser();

    return (
      <>
        <NavBar user={user} />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1 className="fw-bold text-capitalize">For Interview</h1>
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="fs-sm text-nowrap">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="fs-sm text-nowrap">{count}</span>
                </div>
              </div>

              <div className="d-flex justify-content-start">
                <p
                  className="align-self-end m-0 cursor-pointer fw-bold"
                  style={{ color: `#D18237` }}
                  onClick={this.showFilter.bind(this)}
                >
                  <i class="bi bi-filter"></i>Filters
                </p>
              </div>
              <div className="d-flex flex-column flex-md-row">
                {showFilters ? (
                  <div className="w-50 me-2 d-flex flex-column">
                    <div className="card mt-1 p-3">
                      <h6 className="fw-bold" style={{ color: "black" }}>
                        <i
                          class="bi bi-arrow-left me-2 cursor-pointer"
                          onClick={this.hideFilter.bind(this)}
                        ></i>
                        Filters
                      </h6>

                      {/* <label className="mt-2">Date</label>
                      <InputFactory
                        type="date"
                        onChange={this.onChangeDate.bind(this)}
                        placeholder="Enter Position"
                      /> */}
                      <div className="d-flex flex-column">
                        {Object.keys(schema.filters || {}).map((field) => {
                          let { type, label, ...options } =
                            schema.filters[field];
                          return (
                            <>
                              <label>{label}</label>
                              <InputFactory
                                key={field}
                                className="ms-1"
                                type={type}
                                field={field}
                                where={{}}
                                onChange={this.onChangeFilter.bind(this, type)}
                                {...options}
                              />
                            </>
                          );
                        })}
                      </div>
                    </div>
                    {showDetails ? (
                      <InterviewDetails
                        appDetails={appDetails}
                        clickView={this.onClickView.bind(this)}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div className=" w-100">
                  <Table
                    fields={schema.fields}
                    onClick={this.clickData.bind(this)}
                    objects={objects}
                    // selectable
                    // collapsable
                    excludeFields={Object.keys(schema.fields).reduce(
                      (acc, key) => {
                        const options = schema.fields[key];
                        if (excludeFields.includes(key)) {
                          acc.push(key);
                        }

                        switch (options._type || options.type) {
                          case "Relation":
                          case "Array":
                          case "Object":
                          case "File":
                            acc.push(key);
                            break;
                          default:
                        }
                        return acc;
                      },
                      excludeFields
                    )}
                    selected={selected}
                    onSelect={this.onSelect.bind(this)}
                    onSelectAll={this.onSelectAll.bind(this)}
                    progress={progress}
                    onClickItem={this.onClickItem.bind(this)}
                    onSort={this.onClickSort.bind(this)}
                    className="mt-1"
                  />
                </div>
              </div>
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(InterviewListPage);
